export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">联系我们</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">爆料投稿、商务合作、问题反馈，欢迎通过以下方式联系</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8 text-center">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-4">
              <i className="ri-mail-send-line text-xl md:text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">爆料投稿</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              如果您有独家爆料线索，欢迎通过投稿通道提交。请提供详细事件描述和可验证的证据材料。
            </p>
          </div>
          <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8 text-center">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
              <i className="ri-briefcase-line text-xl md:text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">商务合作</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              广告投放、品牌合作、内容授权等商务事宜，请通过合作通道与我们取得联系。
            </p>
          </div>
          <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8 text-center">
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-4">
              <i className="ri-error-warning-line text-xl md:text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">问题反馈</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              遇到访问问题或内容错误？请通过反馈通道告知我们，技术团队将尽快处理。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}